import { useState, type FormEvent } from 'react';
import { useNavigate } from 'react-router-dom';
import { apiClient } from '../api/client';
import { useAuthStore } from '../store/auth';
import PhoneInput from '../components/PhoneInput';
import PasswordInput from '../components/PasswordInput';

export default function LoginPage() {
  const [phone, setPhone] = useState('');
  const [password, setPassword] = useState('');
  const [error, setError] = useState<string | null>(null);
  const [loading, setLoading] = useState(false);
  const login = useAuthStore((s) => s.login);
  const navigate = useNavigate();

  async function handleSubmit(e: FormEvent) {
    e.preventDefault();
    setError(null);
    setLoading(true);
    try {
      const { data } = await apiClient.post('/auth/login', { phone, password });
      if (data.user.role === 'TECHNICIAN') {
        setError('Эта панель предназначена для диспетчеров и администраторов');
        return;
      }
      login(data.accessToken, data.user);
      navigate('/');
    } catch (err: unknown) {
      // Раньше на любую неудачу — «Неверный телефон или пароль», и при обрыве связи (фильтр
      // провайдера, VPN — см. operations.md) человек раз за разом перепроверял верный пароль
      const status = (err as { response?: { status?: number } }).response?.status;
      if (status === undefined) {
        setError('Нет связи с сервером — проверьте интернет или VPN и попробуйте ещё раз');
      } else if (status === 429) {
        setError('Слишком много попыток входа — подождите минуту и попробуйте снова');
      } else if (status >= 500) {
        setError('Сервер не ответил — попробуйте ещё раз через минуту');
      } else {
        setError('Неверный телефон или пароль');
      }
    } finally {
      setLoading(false);
    }
  }

  return (
    <div className="auth-screen">
      <form className="auth-card" onSubmit={handleSubmit}>
        <h1>Control Brigade</h1>
        <p className="auth-subtitle">Труба-Дело · диспетчерская панель</p>

        <label>
          Телефон
          <PhoneInput value={phone} onChange={setPhone} />
        </label>
        <label>
          Пароль
          <PasswordInput value={password} onChange={setPassword} autoComplete="current-password" />
        </label>

        {error && <div className="error-text">{error}</div>}

        <button type="submit" disabled={loading}>
          {loading ? 'Входим...' : 'Войти'}
        </button>
      </form>
    </div>
  );
}
